import { Box, Grid, Typography, Badge } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import DataService from "../../../../../../Service";
import ChartLoader from "../ChartLoader";
import { makeStyles } from "@material-ui/core";
import { Bar } from "react-chartjs-2";
import DashboardChartService from "../DashboardChartService";
import SettingsIcon from "@material-ui/icons/Settings";
import NotFoundFallback from "./NotFoundFallBack";
import chartConstants from "../ChartConstants";

let constants = {
  labels: [],
  datasets: [
    {
      label: "Number of assignments",
      maxBarThickness: 40,
      data: [],
      backgroundColor: [
        "#40bac6",
        "#40bac6",
        "#40bac6",
        "#40bac6",
        "#40bac6",
        "#40bac6",
      ],
      borderColor: [
        "#40bac6",
        "#40bac6",
        "#40bac6",
        "#40bac6",
        "#40bac6",
        "#40bac6",
      ],
      borderWidth: 1,
    },
  ],
};

function AssignmentStatusGraph(props) {
  const { plainView, fullStats } = props;
  const [userData, setUserData] = useState({
    assignment: "",
    organisation: "",
  });
  //
  const { id: organisationId } = props?.organisationId || 9;
  const [open, setOpen] = React.useState(false);
  const [currentChartDataArr, setCurrentChartDataArr] = useState([]);
  const [checked, setChecked] = useState({});
  const [assignmentStatusChartData, setAssignmentStatusChartData] = useState({
    ...constants,
  });
  const [chartLoader, setChartLoader] = useState(true);

  useEffect(() => {
    getAssignmentStatusGraph(organisationId);
    setChartLoader(true);
  }, [organisationId]);

  const fullStatsDataFilter = (response) => {
    const itemsArray = [
      "in progress",
      "received",
      "shortlist",
      "completed",
      "chemistry",
      "cancelled",
      "all",
    ];
    const filterCondition = (el) =>
      el.value > 0 && !itemsArray.includes(el.label.toLowerCase());
    const responseData = response.statistics
      .filter((el) => filterCondition(el))
      .map((el) => el.value);
    const responseLabels = response.statistics
      .filter((el) => filterCondition(el))
      .map((el) => el.label);
    setAssignmentStatusChartData((prev) => {
      const newData = { ...prev };
      newData.datasets[0].label = "Number of assignments";
      newData.datasets[0].data = [...responseData];
      newData.labels = [...responseLabels];
      // console.log(newData,"new data new",response.data[0].value)
      return newData;
    });
    var localArr = [];
    var checkedData = {};
    responseLabels.map((option, i) => {
      var pdata = {};
      pdata["checked"] = true;
      pdata["name"] = option;
      pdata["value"] = responseData[i];
      checkedData[option] = true;
      localArr.push(pdata);
    });
    setChecked({ ...checked, ...checkedData });
    setCurrentChartDataArr(localArr);
  };
  const assignmentStatsDataFilter = (response) => {
    const updateAssignmentStatusChartData = {
      ...assignmentStatusChartData,
    };
    // console.log(organisationId,"more")
    if (response.data.length > 2 && !organisationId) {
      // console.log(response.data.length,organisationId,"org")
      updateAssignmentStatusChartData.selectOrg = true;
    } else {
      updateAssignmentStatusChartData.selectOrg = false;
      updateAssignmentStatusChartData.datasets[0].data = response.data[0].value;
      updateAssignmentStatusChartData.labels = response.data[0].labels;
    }

    setAssignmentStatusChartData(updateAssignmentStatusChartData);
    var localArr = [];
    var checkedData = {};
    response.data[0].labels.map((option, i) => {
      var pdata = {};
      pdata["checked"] = true;
      pdata["name"] = option;
      pdata["value"] = updateAssignmentStatusChartData.datasets[0].data[i];
      checkedData[option] = true;
      localArr.push(pdata);
    });
    setChecked({ ...checked, ...checkedData });
    setCurrentChartDataArr(localArr);
  };

  const getAssignmentStatusGraph = (organisationId) => {
    let url = "dashboards/assignment_status_graph";
    let params = { organisation_id: organisationId };
    if (fullStats) {
      url = "assignments/statistics";
      params.type = "organisation";
    }
    console.log("requesting response");
    DataService.getDirectData(url, params).then((response) => {
      console.log("receiving response");
      if (fullStats) {
        fullStatsDataFilter(response);
      } else {
        assignmentStatsDataFilter(response);
      }

      setChartLoader(false);
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = (value) => {
    setOpen(false);
  };

  const afterUpdateGraph = (objArr, checkedArr) => {
    const filteredCurrentChartDataArr = objArr.filter(
      (option) => option.checked
    );
    const newAssignmentStatusChartData = { ...assignmentStatusChartData };
    newAssignmentStatusChartData.datasets[0].data =
      filteredCurrentChartDataArr.map((option, i) => option.value);
    newAssignmentStatusChartData.labels = filteredCurrentChartDataArr.map(
      (option, i) => option.name
    );
    setAssignmentStatusChartData(newAssignmentStatusChartData);
    setChecked(checkedArr);
    handleClose();
  };
  const MainStyle = { boxShadow: 4, padding: 1 };
  if (plainView) {
    MainStyle.boxShadow = 0;
    MainStyle.padding = 0;
  }
  return (
    <Box width="100%">
      <Box {...MainStyle} style={{ borderRadius: "5px" }}>
        <Grid container direction="row" alignItems="center">
          <Grid item xs={12}>
            <Grid container direction="row" alignItems="center">
              <Grid item xs={11}>
                <Typography
                  variant="subtitle1"
                  color="secondary"
                  style={{
                    height: "47px",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <Box
                    fontWeight="fontWeightBold"
                    style={{ marginLeft: "26px" }}
                  >
                    Assignment status
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Box
                  textAlign="center"
                  className="settings_icon_assignments_graph"
                >
                  <Badge color="primary" onClick={handleClickOpen}>
                    <SettingsIcon style={{ cursor: "pointer" }} />
                  </Badge>
                </Box>
              </Grid>
            </Grid>
            <Box width={1}>
              {chartLoader.assignmentStatusChartData ? (
                <ChartLoader />
              ) : (
                <AssignmentByStatus
                  organisation={userData.organisation}
                  assignmentByStatus={assignmentStatusChartData}
                  options={chartConstants.options}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
      {open && (
        <DashboardChartService
          currentChartDataArr={currentChartDataArr}
          setCurrentChartDataArr={setCurrentChartDataArr}
          afterUpdateGraph={afterUpdateGraph}
          open={open}
          handleClose={handleClose}
          grpahChecked={checked}
          assignmentList={true}
        />
      )}
    </Box>
  );
}

export default AssignmentStatusGraph;

const AssignmentByStatus = React.memo(
  (props) => {
    const dataLength = props.assignmentByStatus.datasets[0].data.length;
    const labelLength = props.assignmentByStatus.labels.length;
    const selectOrg = props.assignmentByStatus.selectOrg;
    console.log(selectOrg, "select org");
    return (
      <>
        {!selectOrg ? (
          dataLength > 0 && labelLength > 0 ? (
            <Bar
              key={Math.random()}
              // id={userData.organisation}
              id={props.organisation}
              // data={assignmentStatusChartData}
              data={props.assignmentByStatus}
              // options={chartConstants.options}
              options={chartConstants.options}
            />
          ) : (
            <NotFoundFallback />
          )
        ) : (
          <NotFoundFallback text="Please select an organisation " />
        )}
      </>
    );
  },

  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.assignmentByStatus) ===
      JSON.stringify(nextProps.assignmentByStatus)
    );
  }
);
